import { GoogleTagManager as GTM } from '@next/third-parties/google'

import isEmpty from 'lodash/fp/isEmpty'

import { SNOWBALL_GTM_ID } from '../constants'

type Props = {
  environment?: string | null
  id?: string
}
export default function GoogleTagManager({
  environment,
  id = SNOWBALL_GTM_ID,
}: Props) {
  if (isEmpty(id)) {
    return false
  }

  return (
    <GTM gtmId={id} preview={isEmpty(environment) ? undefined : environment} />
  )
}
